import { call, put, select, takeLatest } from 'typed-redux-saga'
import { errorHandler, loadersSlice, gridSlice } from 'Modules'
import { Deserialize } from 'cerialize'
import { ResponseCatalog, RequestParams } from 'Models'
import {
	productOrderStatusesSlice,
	ProductOrderStatusestNS,
	productOrderStatusesApi,
	ProductOrderStatusModel,
	productOrderStatusesSelector,
} from 'Pages/admin'

function* getAll(action: ProductOrderStatusestNS.GetAll) {
	try {
		const { params, clear, callback } = action.payload
		yield* put(gridSlice.actions.setLoading(true))
		if (clear) {
			yield* put(productOrderStatusesSlice.actions.clearAll())
		}
		const res = yield* call(productOrderStatusesApi.getAll, params)
		const items = new ResponseCatalog<ProductOrderStatusModel>(res)
		items.entries = items.entries.map(
			(item): ProductOrderStatusModel => Deserialize(item, ProductOrderStatusModel)
		)
		if (!clear) {
			const oldItems = yield* select(productOrderStatusesSelector.getAll)
			items.entries = [...oldItems.entries, ...items.entries]
		}
		yield* put(productOrderStatusesSlice.actions.setAll(items))
		yield* put(productOrderStatusesSlice.actions.setParams(params))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* updateOne(action: ProductOrderStatusestNS.UpdateOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { data, id } = action.payload
		yield* call(productOrderStatusesApi.updateOne, data, id)
		yield* put(
			productOrderStatusesSlice.actions.getAll({
				params: new RequestParams(),
				clear: true,
			})
		)
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export const productOrderStatusesSaga = function* saga() {
	yield* takeLatest(productOrderStatusesSlice.actions.getAll.type, getAll)
	yield* takeLatest(productOrderStatusesSlice.actions.updateOne, updateOne)
}
